module.exports = __webpack_public_path__ + "img/hr-train-stop-top.099d48f3.png";